import React from "react";
import { Button } from "@material-ui/core";

import Popup from "../popup";
import { AddNewULDStyle } from "./style";
import { sourceId } from "@utils/constant";

function AddNewULD(props) {
  const classes = AddNewULDStyle();
  return (
    <div className={classes.AddNewItemWrapper}>
      {props.jobsData?.sourceId !== sourceId.CARGO_WISE && props.jobsData?.invoiceGenerated === false && (
        <Button
          className="orange-btn primary-btn"
          color="inherit"
          underlinenone="true"
          disabled={props.isMismatch}
          onClick={props.handleClickOpen}
        >
          + Add new ULD
        </Button>
      )}
      <Popup
        formik={props.formik}
        open={props.open}
        handleClose={props.handleClose}
        isEdit={props.isEdit}
        error={props.error}
        jobsData={props.jobsData}
      />
    </div>
  );
}
export default AddNewULD;
